<ph-dialog [open]="open" size="md" heading="Confirm Bank Selection" (ph-close)="closed.emit(null)">
    <span>PayHOA already has a connection to {{ bankName }}. Do you want to add an additional account to your existing connection, or connect a new set of online banking credentials?</span>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" aria-label="cancel" (click)="closed.emit(null)">Cancel</ph-button>
        <ph-button variant="secondary" mode="filled" aria-label="secondary action" (click)="closed.emit('new')">Connect a new account</ph-button>
        <ph-button aria-label="confirm" (click)="closed.emit('existing')">Add account to existing connection</ph-button>
    </ph-actions>
</ph-dialog>
